@if (filterItems.length) {
  <div class="applied-filter box-shadow">
    <mat-nav-list>
      <a mat-list-item class="applied-filter-title" (click)="clearAll()"><span fxFlex=""><span>{{ 'globalUi.filter.applied' | translate }}</span><span fxFlex=""></span><img alt="" src="assets/icons/remove-24px-2.svg"></span></a>
      @for (item of filterItems; track item; let index = $index) {
        <a mat-list-item class="applied-filter-item" (click)="clearItem(index)">
          <span fxFlex="">
            <span>{{item.value}}</span>
            <span fxFlex=""></span>
            <img alt="" src="assets/icons/remove-24px-2.svg">
          </span>
        </a>
      }
    </mat-nav-list>
  </div>
}
